import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BoxComponent, PlaceloaderComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-panel-skeleton',
  templateUrl: './evaluation-panel-skeleton.component.html',
  styleUrls: ['./evaluation-panel-skeleton.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BoxComponent, PlaceloaderComponent],
})
export class EvaluationPanelSkeletonComponent {}
